import React from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from '@material-ui/core';


const ModMedRefundInfoDialog = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Refund via ModMed Pay</DialogTitle>
    <DialogContent>
      <p>To request a refund for payments made through ModMed Pay, follow these steps:</p>
      <h3>Accessing the ModMed Pay Dashboard</h3>
      <p><strong>Ensure Permissions:</strong></p>
      <ul>
        <li>Users must have the Refund Payments permission to access refund functionalities in the ModMed Pay Dashboard.</li>
      </ul>
      <p><strong>Setting the Refund Payments Permission:</strong></p>
      <ul>
        <li>Log in to Firm Admin.</li>
        <li>Navigate to User Permissions.</li>
        <li>Switch to the ModMed Pay tab.</li>
        <li>Select Refund Payments for the relevant users and save the changes.</li>
      </ul>
      <h3>Navigating to the ModMed Pay Dashboard</h3>
      <ul>
        <li>Log in as a staff user.</li>
        <li>Go to Analytics and then Financials.</li>
        <li>Click on Dashboard under the ModMed Pay section to open the ModMed Pay Dashboard.</li>
      </ul>
      <h3>Refunding a Payment from the ModMed Pay Dashboard</h3>
      <ul>
        <li>On the Transactions tab of the ModMed Pay Dashboard, filter for the relevant payment.</li>
        <li>Tip: Filtering by the location &ldquo;E-Store&ldquo; or by the source &ldquo;DermPRO&ldquo; can help locate payments made through DermPRO more easily.</li>
        <li>Click on View in the actions column for the relevant payment to display the Transaction Details screen.</li>
        <li>Click on the Refund Payment button to open the Refund Payment screen.</li>
        <li>Select either Full Amount or Custom Amount and set the amount to refund.</li>
        <li>Click on the Refund button to request the refund.</li>
      </ul>
      <p>By following these steps, users can efficiently process refunds for payments made through ModMed Pay. If you encounter any issues, please contact our support team for assistance.</p>
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={onClose}
        className="w-100 uppercase"
      >
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ModMedRefundInfoDialog;
